'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import http from 'hub-http/clients/noPortalApiClient';
import isValidURL from '../utils/urlValidator';
import { parse } from 'hub-http/helpers/params';
export default function AuthRedirection(props) {
  useEffect(() => {
    const parsedQuery = parse(props.location.search);
    const referer = parsedQuery.referer || parsedQuery['?referer'];
    http.get('https://api.hubspot.com/khoros/integration/auth/jwt/token').then(result => {
      document.cookie = `Crowdvocate_jwt_token=${result['jwtToken']}; Path=/; Domain=.hubspot.com; Secure`;
      document.cookie = `lithiumSSO%3Amjmao93648=${result['ssoToken']}; Path=/; Domain=.hubspot.com; Secure`;
      window.location = isValidURL(referer) ? referer : 'https://community.hubspot.com';
    }).catch(error => {
      if (error.status === 400 && error.responseJSON.message.includes('impersonating')) {
        window.location = '/login-as-error';
      }
    });
  });
  return /*#__PURE__*/_jsx(_Fragment, {});
}